/*
 * The "Apply edition" request of the product form (SYN-3464): what the dialog asks, what it refuses before any call,
 * how it is sent to GET /v1/licensing/edition-grants and how the reply becomes rows of the form's license list.
 */

export const EDITION_OPTIONS = Object.freeze([
	{ value: 'standard', label: 'Standard' },
	{ value: 'advanced', label: 'Advanced' }
]);

export const DURATION_TYPE_OPTIONS = Object.freeze([
	{ value: 'days', label: 'Days' },
	{ value: 'months', label: 'Months' },
	{ value: 'years', label: 'Years' }
]);

export const DEFAULT_EDITION_REQUEST = Object.freeze({
	editionCode: '',
	startDate: '',
	startOnActivation: false,
	duration: '',
	durationType: 'months'
});

const isPositiveWholeNumber = (value) => {
	return /^\d+$/.test(String(value).trim()) && Number(value) > 0;
};

/*
 * The checks the server makes, done first so nothing is asked for a request it would refuse: an edition, a start
 * (a date or the activation) and a duration above 0.
 */
export const validateEditionRequest = (request) => {
	const errors = {};

	if (!EDITION_OPTIONS.some((option) => { return option.value === request.editionCode; })) {
		errors.editionCode = 'Choose an edition';
	}
	if (!request.startOnActivation && !request.startDate) {
		errors.startDate = 'Give a start date or tick Start on activation';
	}
	if (request.duration === '' || request.duration === null || request.duration === undefined) {
		errors.duration = 'Cannot be empty';
	} else if (!isPositiveWholeNumber(request.duration)) {
		errors.duration = 'Must be a positive whole number';
	}
	if (!DURATION_TYPE_OPTIONS.some((option) => { return option.value === request.durationType; })) {
		errors.durationType = 'Choose days, months or years';
	}

	return errors;
};

/*
 * The query of the route. It takes exactly one of `startDate` (a calendar day) and `startOnActivation`.
 */
export const toEditionGrantsQuery = (request) => {
	const query = {
		editionCode: request.editionCode,
		duration: Number(request.duration),
		durationType: request.durationType
	};

	if (request.startOnActivation) {
		query.startOnActivation = true;
	} else {
		query.startDate = request.startDate;
	}

	return query;
};

/*
 * The reply's rows as the form's license list holds them: a client uuid, no Forever flag, and the dates as the
 * route gave them. They are ordinary rows from here on: editable, removable and saved with the product.
 */
export const toEditionGrantRows = (items, makeUuid) => {
	return (items || []).map((item) => {
		return {
			uuid: makeUuid(),
			addonId: item.addonId,
			tierId: item.tierId ?? '',
			addonType: item.addonType || 'Time-based',
			duration: item.duration,
			durationType: item.durationType,
			startDate: item.startOnActivation ? null : (item.startDate ?? null),
			startOnActivation: Boolean(item.startOnActivation),
			endDate: item.endDate ?? undefined,
			isForever: false
		};
	});
};
